import script from "./NotCertificationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NotCertificationSection.vue?vue&type=script&setup=true&lang=js"

import "./NotCertificationSection.vue?vue&type=style&index=0&id=6cca1531&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cca1531"]])

export default __exports__